export function windowPushHistory(url) {
    window.history.pushState(null, null, url);
}
export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
export function getElementCoords(element) {
    const box = element.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset,
        right: box.right + window.pageXOffset,
        bottom: box.bottom + window.pageYOffset,
        left: box.left + window.pageXOffset,
    };
}
export function scrollToElement(selector, offsetTop = 0) {
    const element = document.querySelector(selector);
    if (element) {
        const coords = getElementCoords(element);
        window.scrollTo(coords.left, coords.top - offsetTop);
    }
    else {
        console.log('Scroll error: element undefined');
    }
}
